import React from 'react'
import { useSelector } from 'react-redux'

import { Grid, Typography } from '@material-ui/core'

import I18n from '@galo-monitor/i18n'
import { AVAILABLE_CONTEXTS } from '@galo-monitor/stores/context'
import { selectCurrentContext } from '@galo-monitor/stores/context/selectorContext'
import colors from '@galo-monitor/styles/colors'
import Screen from '@galo-monitor/web-components/Screen'
import PropertyDashboardScreen from '@galo-monitor/web-containers/screens/authenticated/property/PropertyDashboardScreen'

const DashboardScreen = () => {
  const currentContext = useSelector(selectCurrentContext)

  switch(currentContext) {
    case AVAILABLE_CONTEXTS.root:
    case AVAILABLE_CONTEXTS.company:
      return (
        <Screen>
          <Grid container justify="center" alignItems="center" style={ { textAlign: 'center', height: '100%' } }>
            <Grid item>
              <Typography variant="h6" style={ { color: colors.grey } }>
                <I18n>environment being developed</I18n>.
              </Typography>
              <Typography variant="h6" style={ { color: colors.grey } }>
                <I18n>soon features will be available</I18n>.
              </Typography>
            </Grid>
          </Grid>
        </Screen>
      )
    case AVAILABLE_CONTEXTS.farm:
    case AVAILABLE_CONTEXTS.property:
      return <PropertyDashboardScreen />
    default: return null
  }
}

export default DashboardScreen
